import { type Registry as Services, service } from '@ember/service';
import { type HasMany, hasMany } from '@ember-data/model';
import { tracked } from '@glimmer/tracking';
import { Type } from '@warp-drive/core-types/symbols';
import type { Hotelinfo } from 'frontend-utils/models';
import type { HotelInfoResponse } from 'lumen/components/settings/competitors/input-autocomplete-competitor';
import {
  BenchmarkInsightCompetitorsCompset,
  type BenchmarkInsightCompetitorsDesiredCompetitor,
} from 'lumen/models';

export default class BenchmarkInsightCompetitorsDesiredCompset extends BenchmarkInsightCompetitorsCompset {
  // @ts-expect-error: Class inheritance
  [Type] = 'benchmark-insight/competitors/desired-compset' as const;

  @hasMany('benchmark-insight/competitors/desired-competitor', {
    async: false,
    inverse: null,
  })
  // @ts-expect-error: Property 'compset' in type 'BenchmarkInsightCompetitorsDesiredCompset' is not assignable to the same property in base type 'BenchmarkInsightCompetitorsCompset'.
  declare compset: HasMany<BenchmarkInsightCompetitorsDesiredCompetitor>;

  @service declare store: Services['store'];

  @tracked hasPrefilledDesiredCompetitors = false;

  // @ts-expect-error: Property 'competitors' in type 'BenchmarkInsightCompetitorsDesiredCompset' is not assignable to the same property in base type 'BenchmarkInsightCompetitorsCompset'.
  get competitors(): BenchmarkInsightCompetitorsDesiredCompetitor[] {
    return [...this.compset];
  }

  // @ts-expect-error: Property 'mapHotelinfoToCompetitor' in type 'BenchmarkInsightCompetitorsDesiredCompset' is not assignable to the same property in base type 'BenchmarkInsightCompetitorsCompset'.
  mapHotelinfoToCompetitor(
    hotelinfo: Hotelinfo | HotelInfoResponse,
  ): BenchmarkInsightCompetitorsDesiredCompetitor {
    const id = 'id' in hotelinfo ? hotelinfo.id : hotelinfo.hotelinfo_id;

    if (id) {
      const existingRecord =
        this.store.peekRecord<BenchmarkInsightCompetitorsDesiredCompetitor>(
          'benchmark-insight/competitors/desired-competitor',
          id,
        );

      if (existingRecord) {
        return existingRecord;
      }
    }

    return this.store.createRecord<BenchmarkInsightCompetitorsDesiredCompetitor>(
      'benchmark-insight/competitors/desired-competitor',
      {
        // @ts-expect-error: Type 'string | number | null' is not assignable to type 'string | null | undefined'.
        id,
        name: hotelinfo.name,
        // @ts-expect-error: Type 'number | null' is not assignable to type 'number | undefined'.
        stars: hotelinfo.stars,
        latitude: hotelinfo.latitude,
        longitude: hotelinfo.longitude,
      },
    );
  }
}
